import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const forgetPasswordApi = createAsyncThunk(
  'master-user/forget-password',
  async (requestHeaders, { rejectWithValue }) => {
    try {
      const response = await fetch(`${ROOT_URL}/master-user/forget-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestHeaders),
      });
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const forgetPassword = createSlice({
  name: 'forgetPassowrd',
  initialState,
  reducers: {
    resetUser: (state) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: false,
      isCompleted: false,
      response: [],
      error: null,
    }),
  },
  extraReducers: {
    [forgetPasswordApi.pending]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [forgetPasswordApi.fulfilled]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      isError: false,
      response: action.payload,
    }),
    [forgetPasswordApi.rejected]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: true,
      error: action.payload,
    }),
  },
});

export default forgetPassword;
